// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/api/user/v1/responses.proto (package gportal.api.user.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { User, UserProfile } from "./user_pb.js";
import { Customer } from "./customer_pb.js";
import { AccessToken } from "../../../type/v1/accesstoken_pb.js";
import { Money } from "../../../type/v1/money_pb.js";
import { DiscordLootPassStatus } from "./discord_pb.js";

/**
 * @generated from enum gportal.api.user.v1.GamecloudSubscriptionStatus
 */
export enum GamecloudSubscriptionStatus {
  /**
   * @generated from enum value: GAMECLOUD_SUBSCRIPTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GAMECLOUD_SUBSCRIPTION_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: GAMECLOUD_SUBSCRIPTION_STATUS_PAUSED = 2;
   */
  PAUSED = 2,

  /**
   * @generated from enum value: GAMECLOUD_SUBSCRIPTION_STATUS_CANCELLED = 3;
   */
  CANCELLED = 3,

  /**
   * @generated from enum value: GAMECLOUD_SUBSCRIPTION_STATUS_NON_RENEWING = 4;
   */
  NON_RENEWING = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(GamecloudSubscriptionStatus)
proto3.util.setEnumType(GamecloudSubscriptionStatus, "gportal.api.user.v1.GamecloudSubscriptionStatus", [
  { no: 0, name: "GAMECLOUD_SUBSCRIPTION_STATUS_UNSPECIFIED" },
  { no: 1, name: "GAMECLOUD_SUBSCRIPTION_STATUS_ACTIVE" },
  { no: 2, name: "GAMECLOUD_SUBSCRIPTION_STATUS_PAUSED" },
  { no: 3, name: "GAMECLOUD_SUBSCRIPTION_STATUS_CANCELLED" },
  { no: 4, name: "GAMECLOUD_SUBSCRIPTION_STATUS_NON_RENEWING" },
]);

/**
 * @generated from message gportal.api.user.v1.GetUserResponse
 */
export class GetUserResponse extends Message<GetUserResponse> {
  /**
   * @generated from field: gportal.api.user.v1.User user = 1;
   */
  user?: User;

  constructor(data?: PartialMessage<GetUserResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.GetUserResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: User },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserResponse {
    return new GetUserResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserResponse {
    return new GetUserResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserResponse {
    return new GetUserResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetUserResponse | PlainMessage<GetUserResponse> | undefined, b: GetUserResponse | PlainMessage<GetUserResponse> | undefined): boolean {
    return proto3.util.equals(GetUserResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.GetCustomerResponse
 */
export class GetCustomerResponse extends Message<GetCustomerResponse> {
  /**
   * @generated from field: gportal.api.user.v1.Customer customer = 1;
   */
  customer?: Customer;

  constructor(data?: PartialMessage<GetCustomerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.GetCustomerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer", kind: "message", T: Customer },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCustomerResponse {
    return new GetCustomerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCustomerResponse {
    return new GetCustomerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCustomerResponse {
    return new GetCustomerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCustomerResponse | PlainMessage<GetCustomerResponse> | undefined, b: GetCustomerResponse | PlainMessage<GetCustomerResponse> | undefined): boolean {
    return proto3.util.equals(GetCustomerResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.CreateCustomerResponse
 */
export class CreateCustomerResponse extends Message<CreateCustomerResponse> {
  /**
   * @generated from field: gportal.api.user.v1.Customer customer = 1;
   */
  customer?: Customer;

  constructor(data?: PartialMessage<CreateCustomerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.CreateCustomerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer", kind: "message", T: Customer },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCustomerResponse {
    return new CreateCustomerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCustomerResponse {
    return new CreateCustomerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCustomerResponse {
    return new CreateCustomerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCustomerResponse | PlainMessage<CreateCustomerResponse> | undefined, b: CreateCustomerResponse | PlainMessage<CreateCustomerResponse> | undefined): boolean {
    return proto3.util.equals(CreateCustomerResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.RegisterUserResponse
 */
export class RegisterUserResponse extends Message<RegisterUserResponse> {
  /**
   * @generated from field: gportal.api.user.v1.User user = 1;
   */
  user?: User;

  /**
   * @generated from field: gportal.type.v1.AccessToken access_token = 2;
   */
  accessToken?: AccessToken;

  constructor(data?: PartialMessage<RegisterUserResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.RegisterUserResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: User },
    { no: 2, name: "access_token", kind: "message", T: AccessToken },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RegisterUserResponse {
    return new RegisterUserResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RegisterUserResponse {
    return new RegisterUserResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RegisterUserResponse {
    return new RegisterUserResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RegisterUserResponse | PlainMessage<RegisterUserResponse> | undefined, b: RegisterUserResponse | PlainMessage<RegisterUserResponse> | undefined): boolean {
    return proto3.util.equals(RegisterUserResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.RegisterUserRequirementsResponse
 */
export class RegisterUserRequirementsResponse extends Message<RegisterUserRequirementsResponse> {
  /**
   * @generated from field: repeated gportal.api.user.v1.RegisterUserRequirementsResponseCountryOption country_options = 1;
   */
  countryOptions: RegisterUserRequirementsResponseCountryOption[] = [];

  /**
   * @generated from field: repeated string countries_requiring_postal_code = 2;
   */
  countriesRequiringPostalCode: string[] = [];

  /**
   * @generated from field: repeated string countries_requiring_full_address = 3;
   */
  countriesRequiringFullAddress: string[] = [];

  /**
   * Every country that has a postal code system. Wider than
   * countries_requiring_postal_code: these are the countries where the field is worth offering,
   * not the ones where we refuse a registration without it.
   *
   * @generated from field: repeated string countries_with_postal_code = 4;
   */
  countriesWithPostalCode: string[] = [];

  constructor(data?: PartialMessage<RegisterUserRequirementsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.RegisterUserRequirementsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "country_options", kind: "message", T: RegisterUserRequirementsResponseCountryOption, repeated: true },
    { no: 2, name: "countries_requiring_postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "countries_requiring_full_address", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "countries_with_postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RegisterUserRequirementsResponse {
    return new RegisterUserRequirementsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RegisterUserRequirementsResponse {
    return new RegisterUserRequirementsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RegisterUserRequirementsResponse {
    return new RegisterUserRequirementsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RegisterUserRequirementsResponse | PlainMessage<RegisterUserRequirementsResponse> | undefined, b: RegisterUserRequirementsResponse | PlainMessage<RegisterUserRequirementsResponse> | undefined): boolean {
    return proto3.util.equals(RegisterUserRequirementsResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.UpdateBillingAddressResponse
 */
export class UpdateBillingAddressResponse extends Message<UpdateBillingAddressResponse> {
  /**
   * @generated from field: gportal.api.user.v1.User user = 1;
   */
  user?: User;

  constructor(data?: PartialMessage<UpdateBillingAddressResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.UpdateBillingAddressResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: User },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateBillingAddressResponse {
    return new UpdateBillingAddressResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateBillingAddressResponse {
    return new UpdateBillingAddressResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateBillingAddressResponse {
    return new UpdateBillingAddressResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateBillingAddressResponse | PlainMessage<UpdateBillingAddressResponse> | undefined, b: UpdateBillingAddressResponse | PlainMessage<UpdateBillingAddressResponse> | undefined): boolean {
    return proto3.util.equals(UpdateBillingAddressResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.GetProfileResponse
 */
export class GetProfileResponse extends Message<GetProfileResponse> {
  /**
   * @generated from field: gportal.api.user.v1.UserProfile profile = 1;
   */
  profile?: UserProfile;

  constructor(data?: PartialMessage<GetProfileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.GetProfileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile", kind: "message", T: UserProfile },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProfileResponse {
    return new GetProfileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProfileResponse {
    return new GetProfileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProfileResponse {
    return new GetProfileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetProfileResponse | PlainMessage<GetProfileResponse> | undefined, b: GetProfileResponse | PlainMessage<GetProfileResponse> | undefined): boolean {
    return proto3.util.equals(GetProfileResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.RegisterUserRequirementsResponseCountryOption
 */
export class RegisterUserRequirementsResponseCountryOption extends Message<RegisterUserRequirementsResponseCountryOption> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  constructor(data?: PartialMessage<RegisterUserRequirementsResponseCountryOption>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.RegisterUserRequirementsResponseCountryOption";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RegisterUserRequirementsResponseCountryOption {
    return new RegisterUserRequirementsResponseCountryOption().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RegisterUserRequirementsResponseCountryOption {
    return new RegisterUserRequirementsResponseCountryOption().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RegisterUserRequirementsResponseCountryOption {
    return new RegisterUserRequirementsResponseCountryOption().fromJsonString(jsonString, options);
  }

  static equals(a: RegisterUserRequirementsResponseCountryOption | PlainMessage<RegisterUserRequirementsResponseCountryOption> | undefined, b: RegisterUserRequirementsResponseCountryOption | PlainMessage<RegisterUserRequirementsResponseCountryOption> | undefined): boolean {
    return proto3.util.equals(RegisterUserRequirementsResponseCountryOption, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.VerifyEmailResponse
 */
export class VerifyEmailResponse extends Message<VerifyEmailResponse> {
  constructor(data?: PartialMessage<VerifyEmailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.VerifyEmailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyEmailResponse {
    return new VerifyEmailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyEmailResponse {
    return new VerifyEmailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyEmailResponse {
    return new VerifyEmailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyEmailResponse | PlainMessage<VerifyEmailResponse> | undefined, b: VerifyEmailResponse | PlainMessage<VerifyEmailResponse> | undefined): boolean {
    return proto3.util.equals(VerifyEmailResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ResendVerificationEmailResponse
 */
export class ResendVerificationEmailResponse extends Message<ResendVerificationEmailResponse> {
  constructor(data?: PartialMessage<ResendVerificationEmailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ResendVerificationEmailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResendVerificationEmailResponse {
    return new ResendVerificationEmailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResendVerificationEmailResponse {
    return new ResendVerificationEmailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResendVerificationEmailResponse {
    return new ResendVerificationEmailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ResendVerificationEmailResponse | PlainMessage<ResendVerificationEmailResponse> | undefined, b: ResendVerificationEmailResponse | PlainMessage<ResendVerificationEmailResponse> | undefined): boolean {
    return proto3.util.equals(ResendVerificationEmailResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ChangePreferredRegionResponse
 */
export class ChangePreferredRegionResponse extends Message<ChangePreferredRegionResponse> {
  constructor(data?: PartialMessage<ChangePreferredRegionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ChangePreferredRegionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangePreferredRegionResponse {
    return new ChangePreferredRegionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangePreferredRegionResponse {
    return new ChangePreferredRegionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangePreferredRegionResponse {
    return new ChangePreferredRegionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangePreferredRegionResponse | PlainMessage<ChangePreferredRegionResponse> | undefined, b: ChangePreferredRegionResponse | PlainMessage<ChangePreferredRegionResponse> | undefined): boolean {
    return proto3.util.equals(ChangePreferredRegionResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ChangeLocaleResponse
 */
export class ChangeLocaleResponse extends Message<ChangeLocaleResponse> {
  constructor(data?: PartialMessage<ChangeLocaleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ChangeLocaleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeLocaleResponse {
    return new ChangeLocaleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeLocaleResponse {
    return new ChangeLocaleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeLocaleResponse {
    return new ChangeLocaleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeLocaleResponse | PlainMessage<ChangeLocaleResponse> | undefined, b: ChangeLocaleResponse | PlainMessage<ChangeLocaleResponse> | undefined): boolean {
    return proto3.util.equals(ChangeLocaleResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ChangeCurrencyResponse
 */
export class ChangeCurrencyResponse extends Message<ChangeCurrencyResponse> {
  /**
   * @generated from field: gportal.type.v1.Money wallet = 1;
   */
  wallet?: Money;

  constructor(data?: PartialMessage<ChangeCurrencyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ChangeCurrencyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "wallet", kind: "message", T: Money },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeCurrencyResponse {
    return new ChangeCurrencyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeCurrencyResponse {
    return new ChangeCurrencyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeCurrencyResponse {
    return new ChangeCurrencyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeCurrencyResponse | PlainMessage<ChangeCurrencyResponse> | undefined, b: ChangeCurrencyResponse | PlainMessage<ChangeCurrencyResponse> | undefined): boolean {
    return proto3.util.equals(ChangeCurrencyResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ChangeTimezoneResponse
 */
export class ChangeTimezoneResponse extends Message<ChangeTimezoneResponse> {
  constructor(data?: PartialMessage<ChangeTimezoneResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ChangeTimezoneResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeTimezoneResponse {
    return new ChangeTimezoneResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeTimezoneResponse {
    return new ChangeTimezoneResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeTimezoneResponse {
    return new ChangeTimezoneResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeTimezoneResponse | PlainMessage<ChangeTimezoneResponse> | undefined, b: ChangeTimezoneResponse | PlainMessage<ChangeTimezoneResponse> | undefined): boolean {
    return proto3.util.equals(ChangeTimezoneResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ChangeParanoidResponse
 */
export class ChangeParanoidResponse extends Message<ChangeParanoidResponse> {
  constructor(data?: PartialMessage<ChangeParanoidResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ChangeParanoidResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeParanoidResponse {
    return new ChangeParanoidResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeParanoidResponse {
    return new ChangeParanoidResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeParanoidResponse {
    return new ChangeParanoidResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeParanoidResponse | PlainMessage<ChangeParanoidResponse> | undefined, b: ChangeParanoidResponse | PlainMessage<ChangeParanoidResponse> | undefined): boolean {
    return proto3.util.equals(ChangeParanoidResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.NewsletterOptInResponse
 */
export class NewsletterOptInResponse extends Message<NewsletterOptInResponse> {
  constructor(data?: PartialMessage<NewsletterOptInResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.NewsletterOptInResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NewsletterOptInResponse {
    return new NewsletterOptInResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NewsletterOptInResponse {
    return new NewsletterOptInResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NewsletterOptInResponse {
    return new NewsletterOptInResponse().fromJsonString(jsonString, options);
  }

  static equals(a: NewsletterOptInResponse | PlainMessage<NewsletterOptInResponse> | undefined, b: NewsletterOptInResponse | PlainMessage<NewsletterOptInResponse> | undefined): boolean {
    return proto3.util.equals(NewsletterOptInResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.NewsletterOptOutResponse
 */
export class NewsletterOptOutResponse extends Message<NewsletterOptOutResponse> {
  constructor(data?: PartialMessage<NewsletterOptOutResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.NewsletterOptOutResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NewsletterOptOutResponse {
    return new NewsletterOptOutResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NewsletterOptOutResponse {
    return new NewsletterOptOutResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NewsletterOptOutResponse {
    return new NewsletterOptOutResponse().fromJsonString(jsonString, options);
  }

  static equals(a: NewsletterOptOutResponse | PlainMessage<NewsletterOptOutResponse> | undefined, b: NewsletterOptOutResponse | PlainMessage<NewsletterOptOutResponse> | undefined): boolean {
    return proto3.util.equals(NewsletterOptOutResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.CheckLootPassDiscordStatusResponse
 */
export class CheckLootPassDiscordStatusResponse extends Message<CheckLootPassDiscordStatusResponse> {
  /**
   * @generated from field: gportal.api.user.v1.DiscordLootPassStatus status = 1;
   */
  status?: DiscordLootPassStatus;

  constructor(data?: PartialMessage<CheckLootPassDiscordStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.CheckLootPassDiscordStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "message", T: DiscordLootPassStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckLootPassDiscordStatusResponse {
    return new CheckLootPassDiscordStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckLootPassDiscordStatusResponse {
    return new CheckLootPassDiscordStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckLootPassDiscordStatusResponse {
    return new CheckLootPassDiscordStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CheckLootPassDiscordStatusResponse | PlainMessage<CheckLootPassDiscordStatusResponse> | undefined, b: CheckLootPassDiscordStatusResponse | PlainMessage<CheckLootPassDiscordStatusResponse> | undefined): boolean {
    return proto3.util.equals(CheckLootPassDiscordStatusResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.LinkLootPassDiscordRoleResponse
 */
export class LinkLootPassDiscordRoleResponse extends Message<LinkLootPassDiscordRoleResponse> {
  constructor(data?: PartialMessage<LinkLootPassDiscordRoleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.LinkLootPassDiscordRoleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LinkLootPassDiscordRoleResponse {
    return new LinkLootPassDiscordRoleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LinkLootPassDiscordRoleResponse {
    return new LinkLootPassDiscordRoleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LinkLootPassDiscordRoleResponse {
    return new LinkLootPassDiscordRoleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: LinkLootPassDiscordRoleResponse | PlainMessage<LinkLootPassDiscordRoleResponse> | undefined, b: LinkLootPassDiscordRoleResponse | PlainMessage<LinkLootPassDiscordRoleResponse> | undefined): boolean {
    return proto3.util.equals(LinkLootPassDiscordRoleResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.Benefit
 */
export class Benefit extends Message<Benefit> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: int32 total = 2;
   */
  total = 0;

  /**
   * @generated from field: int32 used = 3;
   */
  used = 0;

  /**
   * @generated from field: optional google.protobuf.Timestamp start_date = 4;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp reset_date = 5;
   */
  resetDate?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_date = 6;
   */
  endDate?: Timestamp;

  constructor(data?: PartialMessage<Benefit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.Benefit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "used", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "start_date", kind: "message", T: Timestamp, opt: true },
    { no: 5, name: "reset_date", kind: "message", T: Timestamp, opt: true },
    { no: 6, name: "end_date", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Benefit {
    return new Benefit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Benefit {
    return new Benefit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Benefit {
    return new Benefit().fromJsonString(jsonString, options);
  }

  static equals(a: Benefit | PlainMessage<Benefit> | undefined, b: Benefit | PlainMessage<Benefit> | undefined): boolean {
    return proto3.util.equals(Benefit, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.SubscriptionInfo
 */
export class SubscriptionInfo extends Message<SubscriptionInfo> {
  /**
   * @generated from field: string product_type = 1;
   */
  productType = "";

  /**
   * @generated from field: optional google.protobuf.Timestamp subscription_start_date = 2;
   */
  subscriptionStartDate?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp subscription_end_date = 3;
   */
  subscriptionEndDate?: Timestamp;

  /**
   * @generated from field: repeated gportal.api.user.v1.Benefit benefits = 6;
   */
  benefits: Benefit[] = [];

  constructor(data?: PartialMessage<SubscriptionInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.SubscriptionInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "product_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subscription_start_date", kind: "message", T: Timestamp, opt: true },
    { no: 3, name: "subscription_end_date", kind: "message", T: Timestamp, opt: true },
    { no: 6, name: "benefits", kind: "message", T: Benefit, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscriptionInfo {
    return new SubscriptionInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscriptionInfo {
    return new SubscriptionInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscriptionInfo {
    return new SubscriptionInfo().fromJsonString(jsonString, options);
  }

  static equals(a: SubscriptionInfo | PlainMessage<SubscriptionInfo> | undefined, b: SubscriptionInfo | PlainMessage<SubscriptionInfo> | undefined): boolean {
    return proto3.util.equals(SubscriptionInfo, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.GetSubscriptionInfosResponse
 */
export class GetSubscriptionInfosResponse extends Message<GetSubscriptionInfosResponse> {
  /**
   * @generated from field: optional string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: repeated gportal.api.user.v1.SubscriptionInfo subscriptions = 2;
   */
  subscriptions: SubscriptionInfo[] = [];

  constructor(data?: PartialMessage<GetSubscriptionInfosResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.GetSubscriptionInfosResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "subscriptions", kind: "message", T: SubscriptionInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSubscriptionInfosResponse {
    return new GetSubscriptionInfosResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSubscriptionInfosResponse {
    return new GetSubscriptionInfosResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSubscriptionInfosResponse {
    return new GetSubscriptionInfosResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSubscriptionInfosResponse | PlainMessage<GetSubscriptionInfosResponse> | undefined, b: GetSubscriptionInfosResponse | PlainMessage<GetSubscriptionInfosResponse> | undefined): boolean {
    return proto3.util.equals(GetSubscriptionInfosResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.GamecloudSubscription
 */
export class GamecloudSubscription extends Message<GamecloudSubscription> {
  /**
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId = "";

  /**
   * @generated from field: gportal.api.user.v1.GamecloudSubscriptionStatus status = 2;
   */
  status = GamecloudSubscriptionStatus.UNSPECIFIED;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp pause_date = 4;
   */
  pauseDate?: Timestamp;

  /**
   * @generated from field: string name = 5;
   */
  name = "";

  /**
   * @generated from field: uint64 order_id = 6;
   */
  orderId = protoInt64.zero;

  constructor(data?: PartialMessage<GamecloudSubscription>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.GamecloudSubscription";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscription_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(GamecloudSubscriptionStatus) },
    { no: 3, name: "end_date", kind: "message", T: Timestamp },
    { no: 4, name: "pause_date", kind: "message", T: Timestamp, opt: true },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "order_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GamecloudSubscription {
    return new GamecloudSubscription().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GamecloudSubscription {
    return new GamecloudSubscription().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GamecloudSubscription {
    return new GamecloudSubscription().fromJsonString(jsonString, options);
  }

  static equals(a: GamecloudSubscription | PlainMessage<GamecloudSubscription> | undefined, b: GamecloudSubscription | PlainMessage<GamecloudSubscription> | undefined): boolean {
    return proto3.util.equals(GamecloudSubscription, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.GetGamecloudSubscriptionsResponse
 */
export class GetGamecloudSubscriptionsResponse extends Message<GetGamecloudSubscriptionsResponse> {
  /**
   * @generated from field: repeated gportal.api.user.v1.GamecloudSubscription subscriptions = 1;
   */
  subscriptions: GamecloudSubscription[] = [];

  constructor(data?: PartialMessage<GetGamecloudSubscriptionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.GetGamecloudSubscriptionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscriptions", kind: "message", T: GamecloudSubscription, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGamecloudSubscriptionsResponse {
    return new GetGamecloudSubscriptionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGamecloudSubscriptionsResponse {
    return new GetGamecloudSubscriptionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGamecloudSubscriptionsResponse {
    return new GetGamecloudSubscriptionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGamecloudSubscriptionsResponse | PlainMessage<GetGamecloudSubscriptionsResponse> | undefined, b: GetGamecloudSubscriptionsResponse | PlainMessage<GetGamecloudSubscriptionsResponse> | undefined): boolean {
    return proto3.util.equals(GetGamecloudSubscriptionsResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.PauseGamecloudSubscriptionResponse
 */
export class PauseGamecloudSubscriptionResponse extends Message<PauseGamecloudSubscriptionResponse> {
  constructor(data?: PartialMessage<PauseGamecloudSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.PauseGamecloudSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PauseGamecloudSubscriptionResponse {
    return new PauseGamecloudSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PauseGamecloudSubscriptionResponse {
    return new PauseGamecloudSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PauseGamecloudSubscriptionResponse {
    return new PauseGamecloudSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PauseGamecloudSubscriptionResponse | PlainMessage<PauseGamecloudSubscriptionResponse> | undefined, b: PauseGamecloudSubscriptionResponse | PlainMessage<PauseGamecloudSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(PauseGamecloudSubscriptionResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ResumeGamecloudSubscriptionResponse
 */
export class ResumeGamecloudSubscriptionResponse extends Message<ResumeGamecloudSubscriptionResponse> {
  constructor(data?: PartialMessage<ResumeGamecloudSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ResumeGamecloudSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResumeGamecloudSubscriptionResponse {
    return new ResumeGamecloudSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResumeGamecloudSubscriptionResponse {
    return new ResumeGamecloudSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResumeGamecloudSubscriptionResponse {
    return new ResumeGamecloudSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ResumeGamecloudSubscriptionResponse | PlainMessage<ResumeGamecloudSubscriptionResponse> | undefined, b: ResumeGamecloudSubscriptionResponse | PlainMessage<ResumeGamecloudSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(ResumeGamecloudSubscriptionResponse, a, b);
  }
}

